import gql from "graphql-tag";

const setWillReplyMutation = gql`
    mutation WillReplyMutation(
        $chatGroupId: String
        $applicant: String
        $mobileAdded: Boolean
        $dismissed: Boolean
    ) {
        setWillReply(
            chatGroupId: $chatGroupId
            applicant: $applicant
            mobileAdded: $mobileAdded
            dismissed: $dismissed
        ) {
            chatGroupAux {
                willReply {
                    dismissed
                    mobileAdded
                    created
                }
            }
        }
    }
`;

export default setWillReplyMutation;
